export const FACTION_ELEMENTALS_CONSTRUCTION_ACTIONS_BONUS = 2;
export const FACTION_ELEMENTALS_BUILDING_CENTRAL_QUARTER_DISCOUNT = 2;

export const ELEMENTALS_CONSTRUCTION_ELEMENTS = {
  EARTH: 'earth',
  FIRE: 'fire',
  WHEAT: 'wheat',
}

export const ELEMENTALS_CONSTRUCTION_BAG = [
  ELEMENTALS_CONSTRUCTION_ELEMENTS.EARTH,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.EARTH,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.EARTH,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.EARTH,

  ELEMENTALS_CONSTRUCTION_ELEMENTS.FIRE,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.FIRE,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.FIRE,

  ELEMENTALS_CONSTRUCTION_ELEMENTS.WHEAT,
  ELEMENTALS_CONSTRUCTION_ELEMENTS.WHEAT,
]